module.exports = __webpack_public_path__ + "img/icon_user-management.fef68743.svg";